module.exports = __webpack_public_path__ + "media/clients/christian-2x-8024fdfd.jpg";